






import { Vue, Component } from "vue-property-decorator";

@Component({})
class AudiobooksPage extends Vue {}
export default AudiobooksPage;
